import { BookingForm } from 'features/booking/bookingForm';
import {
	ClientFormProvider,
	BookingClientForm,
} from 'features/booking/BookingClientForm';
import { BookingDateTime } from 'features/booking/bookingDateTime';
import { BookingSlotsProvider, BookingSlots } from 'features/booking/slots';
import { Panel } from 'shared/ui/panel';
import { Content } from './styles';
import { Footer } from '../footer/footer';
import { Header } from '../header/header';
import { FC, useState } from 'react';
import { BookingProps } from '../types';
import { ModalProvider } from 'shared/ui/modal';
import { PersonModalCard } from 'widgets/personModalCard';
import { BookingManualOrder } from 'features/booking/bookingManualOrder';
import { useAppSelector } from 'shared/lib/store';
import { selectBookingApplicationMod } from 'entities/orders';
// import { BookingDeposite } from 'features/booking/BookingDeposite';

export const BookingPanel: FC<BookingProps> = props => {
	const [prohibitToClose, setProhibitToClose] = useState(false);
	const { resetPersonAfterClose } = props;
	const applicationMod = useAppSelector(selectBookingApplicationMod);

	const toProhibitClose = (isClose: boolean = true) => {
		setProhibitToClose(isClose);
	};

	return (
		<Panel height={'100dvh'} mediaHeight={false}>
			<BookingSlotsProvider>
				<ClientFormProvider>
					<Header
						prohibitToClose={prohibitToClose}
						toProhibitClose={toProhibitClose}
					/>
					<Content id='booking-scrollable'>
						<BookingDateTime />
						<BookingManualOrder />
						{!applicationMod && <BookingSlots />}
						<BookingForm />
            {/* <BookingDeposite orderArg={null}/> */}
						<ModalProvider>
							<BookingClientForm />
							<PersonModalCard
                updatePersonBook={true}
								hideBookingBtn={true}
								resetPersonAfterClose={resetPersonAfterClose}
								showOrderEdit={false}
							/>
						</ModalProvider>
					</Content>
					<Footer {...props} toProhibitClose={toProhibitClose} />
				</ClientFormProvider>
			</BookingSlotsProvider>
		</Panel>
	);
};
